/**
 * SusurroMark — Susurro brand icon (private E2E chat).
 *
 * A conversation bubble containing a "whisper" wave (soft bars,
 * like a low encrypted voice) and a small verification padlock: end-to-end
 * encrypted messaging that *feels* private. Inline SVG (sharp
 * scaling, theme-aware via brand oklch). No text.
 */

import type { JSX } from "solid-js";

interface SusurroMarkProps {
  size?: number | string;
  class?: string;
  /** Accessible label; decorative by default (aria-hidden). */
  title?: string;
}

export function SusurroMark(props: SusurroMarkProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 64 64"
      width={props.size ?? 64}
      height={props.size ?? 64}
      class={props.class}
      role={props.title === undefined ? "presentation" : "img"}
      aria-hidden={props.title === undefined ? "true" : undefined}
      aria-label={props.title}
    >
      <defs>
        <linearGradient id="su-bubble" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stop-color="oklch(0.74 0.13 278)" />
          <stop offset="0.55" stop-color="oklch(0.64 0.15 285)" />
          <stop offset="1" stop-color="oklch(0.66 0.12 220)" />
        </linearGradient>
        <linearGradient id="su-gloss" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stop-color="oklch(1 0 0 / 0.4)" />
          <stop offset="0.55" stop-color="oklch(1 0 0 / 0)" />
        </linearGradient>
      </defs>

      {/* Burbuja de chat con cola inferior-izquierda. */}
      <path
        d="M14 7 h36 a11 11 0 0 1 11 11 v20 a11 11 0 0 1 -11 11 H27 l-13 10 v-10 a11 11 0 0 1 -11 -11 V18 a11 11 0 0 1 11 -11 z"
        fill="url(#su-bubble)"
        stroke="oklch(0.32 0.05 290 / 0.28)"
        stroke-width="1"
      />
      <path d="M18 11 h30 a7 7 0 0 1 7 7 v5 H11 v-5 a7 7 0 0 1 7 -7 z" fill="url(#su-gloss)" />

      {/* Onda de susurro: barras suaves y simétricas (una voz baja). */}
      <g
        fill="none"
        stroke="oklch(0.98 0.01 280)"
        stroke-width="3.4"
        stroke-linecap="round"
        opacity="0.95"
      >
        <line x1="19" y1="25" x2="19" y2="31" />
        <line x1="26" y1="21" x2="26" y2="35" />
        <line x1="33" y1="17.5" x2="33" y2="38.5" />
        <line x1="40" y1="21" x2="40" y2="35" />
        <line x1="47" y1="25" x2="47" y2="31" />
      </g>

      {/* Candado de verificación (badge inferior-derecha). */}
      <g transform="translate(45 43)">
        <circle r="12" fill="oklch(0.8 0.1 190)" stroke="oklch(0.2 0.03 290)" stroke-width="1.5" />
        <path
          d="M-4 -1 v-2.4 a4 4 0 0 1 8 0 v2.4"
          fill="none"
          stroke="oklch(0.2 0.04 200)"
          stroke-width="2"
          stroke-linecap="round"
        />
        <rect x="-5.4" y="-1" width="10.8" height="8.4" rx="2.2" fill="oklch(0.2 0.04 200)" />
      </g>
    </svg>
  );
}
